import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays, MapPin, ShoppingBag, Trash2 } from "lucide-react";
import { useCart } from "../lib/cart";

const money = (kurus) => `${((kurus || 0) / 100).toLocaleString("tr-TR")} TL`;
const pick = (field) => typeof field === "string" ? field : field?.tr || field?.en || "Eğitim";

export default function Cart() {
  const { items, remove, clear } = useCart();
  const total = items.reduce((sum, item) => sum + (item.price_kurus || 0), 0);

  if (!items.length) return (
    <section className="container-x py-20 md:py-28 text-center">
      <ShoppingBag className="w-10 h-10 mx-auto mb-4 text-ink/30" strokeWidth={1.25} />
      <h1 className="font-serif text-4xl text-ink">Sepetiniz boş</h1>
      <p className="mt-3 text-ink/60">İncelemek istediğiniz eğitimleri sepete ekleyebilirsiniz.</p>
      <Link to="/trainings" className="btn-primary mt-7">Eğitimleri İncele <ArrowRight className="w-4 h-4" /></Link>
    </section>
  );

  return (
    <section className="container-x py-12 md:py-20">
      <div className="flex items-end justify-between gap-4 mb-9">
        <div><span className="label-eyebrow">Sepet</span><h1 className="mt-4 font-serif text-4xl md:text-6xl text-ink">Eğitim sepetiniz</h1></div>
        <button onClick={clear} className="text-sm text-ink/50 hover:text-terracotta-500">Sepeti boşalt</button>
      </div>
      <div className="grid lg:grid-cols-12 gap-8 items-start">
        <div className="lg:col-span-8 space-y-3">
          {items.map((item) => <article key={item.slug} className="surface-card p-4 flex gap-4 items-start">
            <div className="w-24 h-16 rounded-lg overflow-hidden bg-cream-200 shrink-0">{item.thumbnail && <img src={item.thumbnail} alt="" className="w-full h-full object-cover" />}</div>
            <div className="min-w-0 flex-1"><Link to={`/trainings/${item.slug}`} className="font-serif text-xl text-ink hover:text-terracotta-400">{pick(item.title)}</Link>
              {item.delivery_mode === "offline" && <div className="mt-2 text-xs text-ink/60 space-y-1">{item.start_at && <p className="flex gap-1.5"><CalendarDays className="w-3.5" />{new Date(item.start_at).toLocaleString("tr-TR", { dateStyle: "medium", timeStyle: "short" })}</p>}{item.venue && <p className="flex gap-1.5"><MapPin className="w-3.5" />{item.venue}</p>}</div>}
            </div><div className="text-right shrink-0"><p className="font-serif text-lg text-terracotta-400">{money(item.price_kurus)}</p><button onClick={() => remove(item.slug)} aria-label="Sepetten kaldır" className="mt-3 text-ink/40 hover:text-terracotta-500"><Trash2 className="w-4 h-4" /></button></div>
          </article>)}
        </div>
        <aside className="lg:col-span-4 surface-card p-6 lg:sticky lg:top-28"><h2 className="font-serif text-2xl">Sipariş özeti</h2><div className="mt-5 pt-4 border-t border-cream-300 flex justify-between text-lg"><span>Toplam</span><strong className="font-serif text-2xl text-terracotta-400">{money(total)}</strong></div>
          <p className="mt-5 text-sm text-ink/60 leading-relaxed">Ödeme adımı iyzico entegrasyonu tamamlandığında bu sayfadan güvenli şekilde açılacak.</p>
          <button disabled className="btn-accent w-full justify-center mt-6 disabled:opacity-50 disabled:cursor-not-allowed">Ödemeye Geç <ArrowRight className="w-4 h-4" /></button>
        </aside>
      </div>
    </section>
  );
}
